import { useEffect } from "react";
import { useNavigate } from "@/lib/router-compat";

/**
 * Consomme un deep-link stocké en sessionStorage par une notification de
 * mention juste avant un `switchAccount` (qui force un reload). Après le
 * reload, on récupère l'URL cible et on y navigue.
 */
export default function PendingDeepLinkConsumer() {
  const navigate = useNavigate();
  useEffect(() => {
    const link = sessionStorage.getItem("thiia.pendingDeepLink");
    if (link) {
      sessionStorage.removeItem("thiia.pendingDeepLink");
      // Léger délai pour laisser les providers s'initialiser.
      setTimeout(() => navigate(link), 50);
    }
  }, [navigate]);
  return null;
}
